import React, { JSX, useContext, useMemo } from 'react'
import { LuArrowLeft, LuArrowRight } from 'react-icons/lu'
import { Box, Flex, Text } from '@chakra-ui/react'
import { addMonths, format, isBefore, isSameMonth } from 'date-fns'

import { DateTimePickerContext } from 'components/form/DateTimePicker/helpers'
import { getDateFormatLocale } from 'utils/getDateFormatLocale'

export const Header = (): JSX.Element => {
  const { dateTimeState, setDateTimeState } = useContext(DateTimePickerContext)

  const {
    datePicker: { month, year },
    props: { onDisplayedMonthChange },
  } = dateTimeState

  const isNextMonthDisabled: boolean = useMemo(
    () => isSameMonth(new Date(year, month, 1), addMonths(new Date(), 11)),
    [month, year],
  )
  const isPrevMonthDisabled: boolean = useMemo(() => isBefore(new Date(year, month, 1), new Date()), [month, year])

  const handleSetNextMonth = () => {
    const newMonth = month === 11 ? 0 : month + 1
    const newYear = month === 11 ? year + 1 : year

    setDateTimeState((state) => ({ ...state, datePicker: { month: newMonth, year: newYear } }))
    onDisplayedMonthChange && onDisplayedMonthChange(newMonth + 1, dateTimeState) // we want to return 1-12 value
  }

  const handleSetPrevMonth = () => {
    const newMonth = month === 0 ? 11 : month - 1
    const newYear = month === 0 ? year - 1 : year

    setDateTimeState((state) => ({ ...state, datePicker: { month: newMonth, year: newYear } }))
    onDisplayedMonthChange && onDisplayedMonthChange(newMonth + 1, dateTimeState) // we want to return 1-12 value
  }

  return (
    <Flex alignItems="center" justifyContent="space-between" marginBottom="26px">
      <Text fontSize="sm">
        {format(new Date(year, month, 1), 'MMMM', { locale: getDateFormatLocale() })} {year}
      </Text>
      <Flex alignItems="center">
        <Box
          marginRight="34px"
          opacity={isPrevMonthDisabled ? 0.5 : 1}
          pointerEvents={isPrevMonthDisabled ? 'none' : 'all'}
          color="green.a200"
        >
          <button onClick={handleSetPrevMonth}>
            <LuArrowLeft size={42} strokeWidth={1} />
          </button>
        </Box>

        <Box
          opacity={isNextMonthDisabled ? 0.5 : 1}
          pointerEvents={isNextMonthDisabled ? 'none' : 'all'}
          color="green.a200"
        >
          <button onClick={handleSetNextMonth}>
            <LuArrowRight size={42} strokeWidth={1} />
          </button>
        </Box>
      </Flex>
    </Flex>
  )
}
